import React, { Suspense, lazy } from 'react';
import { Dashboard } from '../components/Dashboard.jsx';
import { SpielgeldRechner } from '../components/SpielgeldRechner.jsx';
import { PageRenderer } from '../components/PageRenderer.jsx';

const AngebotKonfigurator = lazy(() => import('../components/AngebotKonfigurator.jsx').then(m => ({ default: m.AngebotKonfigurator || m.default })));
const FlyerGenerator = lazy(() => import('../components/FlyerGenerator.jsx').then(m => ({ default: m.FlyerGenerator || m.default })));
const DesignCustomizer = lazy(() => import('../components/DesignCustomizer.jsx').then(m => ({ default: m.DesignCustomizer || m.default })));
const BruttoNettoRechner = lazy(() => import('../components/BruttoNettoRechner.jsx').then(m => ({ default: m.BruttoNettoRechner || m.default })));
const SmartphoneDB = lazy(() => import('../components/SmartphoneDB.jsx').then(m => ({ default: m.SmartphoneDB || m.default })));
const RouterDB = lazy(() => import('../components/RouterDB.jsx').then(m => ({ default: m.RouterDB || m.default })));
const AbschlussReport = lazy(() => import('../components/AbschlussReport.jsx').then(m => ({ default: m.AbschlussReport || m.default })));
const WKZRechner = lazy(() => import('../components/WKZRechner.jsx').then(m => ({ default: m.WKZRechner || m.default })));

export function AppRoutes({ 
  activeSection, 
  setActiveSection,
  tariffs, 
  selectedTariffIds, 
  eventSettings, 
  setAdminPanelOpen,
  children 
}) {
  if (activeSection.startsWith('/p/')) {
    return (
      <Suspense fallback={<div style={{padding:'2rem',color:'#7dd3fc',textAlign:'center'}}>Lade Seite...</div>}>
        <PageRenderer pageId={activeSection.replace('/p/', '')} />
      </Suspense>
    );
  }
  
  if (activeSection === "dashboard") {
    return (
      <Dashboard
        tariffs={tariffs}
        selectedCount={selectedTariffIds.length}
        activeEvent={eventSettings?.activeEvent}
        onNavigateToCards={() => setActiveSection("cards")}
        onOpenAdmin={() => setAdminPanelOpen(true)}
      />
    );
  }
  
  if (activeSection === "spielgeld") {
    return <SpielgeldRechner />;
  }
  if (activeSection === "bruttonetto") {
    return (
      <Suspense fallback={<div style={{padding:'2rem',color:'#7dd3fc',textAlign:'center'}}>Lade...</div>}>
        <BruttoNettoRechner />
      </Suspense>
    );
  }
  if (activeSection === "konfigurator") {
    return (
      <Suspense fallback={<div style={{padding:'2rem',color:'#7dd3fc',textAlign:'center'}}>Konfigurator laden...</div>}>
        <AngebotKonfigurator />
      </Suspense>
    );
  }
  if (activeSection === "smartphones") {
    return (
      <Suspense fallback={<div style={{padding:'2rem',color:'#7dd3fc',textAlign:'center'}}>Smartphones laden...</div>}>
        <SmartphoneDB />
      </Suspense>
    );
  }
  if (activeSection === "router") {
    return (
      <Suspense fallback={<div style={{padding:'2rem',color:'#7dd3fc',textAlign:'center'}}>Router laden...</div>}>
        <RouterDB />
      </Suspense>
    );
  }
  if (activeSection === "abschluss") {
    return (
      <Suspense fallback={<div style={{padding:'2rem',color:'#7dd3fc',textAlign:'center'}}>Tagesabschluss laden...</div>}>
        <AbschlussReport />
      </Suspense>
    );
  }
  if (activeSection === "wkz") {
    return (
      <Suspense fallback={<div style={{padding:'2rem',color:'#7dd3fc',textAlign:'center'}}>WKZ Rechner laden...</div>}>
        <WKZRechner />
      </Suspense>
    );
  }
  if (activeSection === "flyer") {
    return (
      <Suspense fallback={<div style={{padding:'2rem',color:'#7dd3fc',textAlign:'center'}}>Flyer Generator laden...</div>}>
        <FlyerGenerator />
      </Suspense>
    );
  }
  if (activeSection === "design") {
    return (
      <Suspense fallback={<div style={{padding:'2rem',color:'#7dd3fc',textAlign:'center'}}>Design Customizer laden...</div>}>
        <DesignCustomizer />
      </Suspense>
    );
  }

  // Fallback (z.B. für activeSection === "cards" oder unbekannte Routen) rendert die children
  return <>{children}</>;
}
